import React, { Component, useEffect, useState, useCallback, useMemo, memo } from 'react';
import { Button, Col, Container, Row, Table } from 'reactstrap';

import I18N from '../I18N';
import YTab from '../c/YTab';
import { T } from '../traks';
import { R } from '../routes';
import { OpenLogin } from '../c/SignupLogin';

import { AUAContainer } from '../AUA';
import API from '../API';
import { site_base } from '../Site';
import { SplitV2ErrorModalInit } from '../c/SplitV2ErrorModal';
import { SplitV2FallbackApplyModalInit } from '../c/SplitV2FallbackApplyModal';

const errcls = (has_error, cls) => cls + (has_error ? " ad_input_error" : "");

class NameEmailBirthdate extends Component {
	constructor(props) {
		super(props);
		const { aua } = this.props;

		this.state = {
            customer_type: aua.me.CustomerType ? aua.me.CustomerType.String : null,
            gender: aua.me.Gender ? aua.me.Gender.String : null,
			screen_name: aua.me.ScreenName,
			email: aua.me.LocalEmail,
            postal_code: aua.me.PostalCode.String,

			auth_password: "",
			email_err: "",
		};
	}

	render() {
		return (
			<form className="profile_form">
			<Row className="pb-4">
				<Col>
					<div className="mb-2"><T>Name</T></div>
					<input className="ad_profile_gray form-control p-3" type="text" name="screen_name" value={this.state.screen_name} readOnly />
				</Col>
			</Row>
            {/*<Row className="pb-4">
                <Col>
					<PostcodeSelector postcode={this.state.postal_code} readOnly />
				</Col>
            </Row>*/}
			<Row className="pb-4">
				<Col>
					<div className="mb-2"><T>Email</T></div>
					<input className={"ad_profile_gray form-control p-3"} type="email" name="email" value={this.state.email} readOnly />
				</Col>
			</Row>
			</form>
		)
	}
}

const AccountPane = (props) => {
	const { aua } = props;
    
	return (
		<div>
			<div>
				<T>DETAILS</T>
			</div>
			<div className="ad_profile_gray">
				<T>Your personal info is never shared with anyone</T>
				<hr className="ad_profile_gray my-4"/>
			</div>

			<NameEmailBirthdate aua={aua}/>
		</div>
	);
}

function PrivacyPane(props) {
	const addr = "info@" + site_base;
	const href = "mailto:" + addr;
	const mailto_link = <a href={href}>{addr}</a>;
	return (
		<div>
			<h2 className="py-3"><T>Privacy</T></h2>
			<T>
			<p>We store the following info about you, if you provided it to us:</p>
			<ul>
				<li>You email address</li>
				<li>Your screen name</li>
				<li>Username and user id for Twitter / Facebook</li>
				<li>Your trade history</li>
				<li>Postal code</li>
				<li>Age</li>
				<li>Gender</li>
				<li>Profession</li>				
			</ul>
			<p>You can see the email address and screen name when
			you edit your profile. Your trade history is available
			under trade history.</p> <p>If you would like to delete
			any of it, send us an email at {mailto_link} and we'll get right to it. Be aware, that if you want to delete your trade
			history, it might affect ongoing games.</p>
			</T>
		</div>
	);
}

const splitV2MkRatioLabel = (ev) => `${ev.RatioNew} : ${ev.RatioOld}`;

const splitV2IsUpcoming = (ev) => ev.Status === "pending" || ev.Status === "preopen_done";

const splitV2StatusMeta = [
	{ code: "pending", label: "Afventer" },
	{ code: "preopen_done", label: "Pre-open udført" },
	{ code: "completed", label: "Fuldført" },
	{ code: "cancelled", label: "Annulleret" },
	{ code: "error", label: "Fejl" },
];

const splitV2StatusLabelByCode = splitV2StatusMeta.reduce((acc, row) => {
	acc[row.code] = row.label;
	return acc;
}, {});

const splitV2StatusLabel = (status) => splitV2StatusLabelByCode[status] || status || "-";

const splitV2HasErrorDetails = (ev) => !!(ev.ErrorCode || ev.ErrorMessage || ev.NeedsManualReview);

const splitV2CanMarkPreOpenDone = (ev) => ev && ev.Status === "error";

const SplitV2EventsTable = ({ events, onMarkPreOpenDone }) => {
	const openErrorModal = (ev) => {
		SplitV2ErrorModalInit({
			SourceEventID: ev.SourceEventID,
			StockLabel: `${ev.Exchange}:${ev.Ticker}`,
			Status: splitV2StatusLabel(ev.Status),
			ErrorCode: ev.ErrorCode,
			ErrorMessage: ev.ErrorMessage,
			NeedsManualReview: ev.NeedsManualReview === true,
		});
	};

	if (events.length === 0) {
		return <p className="mt-4">Ingen split-events fundet.</p>;
	}

	return (
		<Table bordered hover responsive size="sm" className="my-boxed-table">
			<thead className="thead-light">
				<tr>
					<th className="text-nowrap">Aktie</th>
					<th style={{ minWidth: 180 }}>Event</th>
					<th>Ratio</th>
					<th className="text-nowrap">Effektiv dato</th>
					<th>Status</th>
					<th>Fejl</th>
					<th>Handling</th>
				</tr>
			</thead>
			<tbody>
				{events.map((ev) => (
					<tr key={ev.ID}>
						<td className="text-nowrap">
							<a className="ad_notification_link" href={R.href('/ticker/:exchange/:ticker', { exchange: ev.Exchange, ticker: ev.Ticker })}>
								{`${ev.Exchange}:${ev.Ticker}`}
							</a>
						</td>
						<td>{ev.SourceEventID || "-"}</td>
						<td className="text-nowrap">{splitV2MkRatioLabel(ev)}</td>
						<td className="text-nowrap">{ev.EffectiveDate || "-"}</td>
						<td className="text-nowrap">{splitV2StatusLabel(ev.Status)}</td>
						<td className="text-nowrap">
							{splitV2HasErrorDetails(ev) ? (
								<Button color="link" size="sm" className="p-0" onClick={() => openErrorModal(ev)}>
									Vis
								</Button>
							) : "-"}
						</td>
						<td className="text-nowrap">
							{splitV2CanMarkPreOpenDone(ev) ? (
								<Button color="link" size="sm" className="p-0" onClick={() => onMarkPreOpenDone(ev)}>
									Markér pre-open done
								</Button>
							) : "-"}
						</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
};

const splitV2SignedFactorToPercent = (signedFactor) => {
	if (!signedFactor || signedFactor === 0) return "0%";
	if (signedFactor > 0) return `${((signedFactor - 1.0) * 100.0).toFixed(0)}%`;
	const absFactor = Math.abs(signedFactor);
	if (absFactor === 0) return "0%";
	return `${(((1.0 / absFactor) - 1.0) * 100.0).toFixed(0)}%`;
};

const splitV2FallbackStatusLabel = (row) => {
	if (row.Status === "resolved_relist") return "Relistet";
	if (row.Status === "resolved_manual") return "Løst manuelt";
	if (row.Status === "resolved_apply_split") return "Split anvendt";
	if (row.Status === "resolved_split_pending_relist") return "Split anvendt (afventer relist)";
	if (row.Status === "failed_apply_split") return "Fejlet (manuel opfølgning)";
	if (row.Status === "open") return row.IsDelisted ? "Delistet" : "Listet - fallback uafklaret";
	return row.Status || "-";
};

const splitV2CanRelist = (row) => {
	return (row.Status === "open" || row.Status === "failed_apply_split" || row.Status === "resolved_split_pending_relist") && row.IsDelisted === true;
};

const splitV2CanDelistAgain = (row) => {
	return (row.Status === "resolved_relist" || row.Status === "resolved_manual" || row.Status === "resolved_apply_split") && row.IsDelisted === false;
};

const splitV2CanApplySplit = (row) => row.Status === "open" && row.IsDelisted === true;

const splitV2HasApplySummary = (row) => row && (row.ApplyHasSummary === true || !!row.ApplyStatus);

const splitV2ParsePositiveInteger = (raw) => {
	const value = Number(String(raw || "").trim().replace(",", "."));
	if (!Number.isFinite(value) || value <= 0 || !Number.isInteger(value)) return null;
	return value;
};

const SplitV2FallbackWatchlistTable = ({ rows, onToggleSeen, onRelist, onDelistAgain, onApplySplit, onOpenApplySummary }) => {
	const [editorRowID, setEditorRowID] = useState(null);
	const [ratioNew, setRatioNew] = useState("");
	const [ratioOld, setRatioOld] = useState("");
	const [note, setNote] = useState("");
	const [editorError, setEditorError] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);

	const resetEditor = useCallback(() => {
		setEditorRowID(null);
		setRatioNew("");
		setRatioOld("");
		setNote("");
		setEditorError("");
		setIsSubmitting(false);
	}, []);

	const submitApply = useCallback((row) => {
		const parsedNew = splitV2ParsePositiveInteger(ratioNew);
		const parsedOld = splitV2ParsePositiveInteger(ratioOld);
		if (!parsedNew || !parsedOld) {
			setEditorError("Ratio skal være positive heltal.");
			return;
		}
		if (parsedNew === parsedOld) {
			setEditorError("Ratio skal ændre aktien (ny og gammel må ikke være ens).");
			return;
		}
		if (!window.confirm(`Anvend split ${parsedNew}:${parsedOld} på ${row.Exchange}:${row.Ticker}?`)) {
			return;
		}

		setEditorError("");
		setIsSubmitting(true);
		onApplySplit(row, { ratio_new: parsedNew, ratio_old: parsedOld, note: note.trim() }, (ok, errMsg) => {
			if (ok) {
				resetEditor();
				return;
			}
			setIsSubmitting(false);
			setEditorError(errMsg || "Anvend split fejlede.");
		});
	}, [note, onApplySplit, ratioNew, ratioOld, resetEditor]);

	if (rows.length === 0) {
		return <p className="mt-4">Ingen rækker i fallback-overvågningslisten.</p>;
	}

	return (
		<Table bordered hover responsive size="sm" className="my-boxed-table mt-4">
			<thead className="thead-light">
				<tr>
					<th className="text-nowrap">Set</th>
					<th className="text-nowrap">Aktie</th>
					<th className="text-nowrap">Dato</th>
					<th className="text-nowrap">Retning</th>
					<th className="text-nowrap">Ændring</th>
					<th className="text-nowrap">Status</th>
					<th className="text-nowrap">Handlinger</th>
				</tr>
			</thead>
			<tbody>
				{rows.map((row) => (
					<React.Fragment key={row.ID}>
						<tr>
							<td className="text-nowrap">
								<input type="checkbox" checked={row.Seen === true} onChange={(e) => onToggleSeen(row.ID, e.target.checked)} />
							</td>
							<td className="text-nowrap">
								<a className="ad_notification_link" href={R.href('/ticker/:exchange/:ticker', { exchange: row.Exchange, ticker: row.Ticker })}>
									{`${row.Exchange}:${row.Ticker}`}
								</a>
							</td>
							<td className="text-nowrap">{row.TriggerTradeDate || "-"}</td>
							<td className="text-nowrap">{row.IsUp ? "Op" : "Ned"}</td>
							<td className="text-nowrap">{splitV2SignedFactorToPercent(row.SignedFactor)}</td>
							<td className="text-nowrap">{splitV2FallbackStatusLabel(row)}</td>
							<td className="text-nowrap">
								{splitV2HasApplySummary(row) ? (
									<Button color="link" size="sm" className="p-0 mr-2" onClick={() => onOpenApplySummary(row)}>
										Vis
									</Button>
								) : null}
								{splitV2CanRelist(row) ? (
									<React.Fragment>
										<Button color="link" size="sm" className="p-0 mr-2" onClick={() => onRelist(row)}>
											Relist
										</Button>
										{splitV2CanApplySplit(row) ? (
											<Button color="link" size="sm" className="p-0" onClick={() => setEditorRowID(row.ID)}>
												Anvend split
											</Button>
										) : null}
									</React.Fragment>
								) : splitV2CanDelistAgain(row) ? (
									<Button color="link" size="sm" className="p-0" onClick={() => onDelistAgain(row)}>
										Delist
									</Button>
								) : !splitV2HasApplySummary(row) ? "-" : null}
							</td>
						</tr>
						{editorRowID === row.ID ? (
							<tr>
								<td colSpan={7}>
									<div className="p-2 border rounded bg-light">
										<div className="font-weight-bold mb-2">Anvend split for {row.Exchange}:{row.Ticker}</div>
										<div className="d-flex align-items-center flex-wrap mb-2">
											<label className="mb-0 mr-2">Ratio</label>
											<input type="text" value={ratioNew} onChange={(e) => setRatioNew(e.target.value)} className="form-control form-control-sm mr-2" style={{ width: 90 }} placeholder="Ny" disabled={isSubmitting} />
											<span className="mr-2">:</span>
											<input type="text" value={ratioOld} onChange={(e) => setRatioOld(e.target.value)} className="form-control form-control-sm mr-3" style={{ width: 90 }} placeholder="Gammel" disabled={isSubmitting} />
										</div>
										<div className="mb-2">
											<label className="mb-1">Note (valgfri)</label>
											<textarea value={note} onChange={(e) => setNote(e.target.value)} className="form-control form-control-sm" rows={2} maxLength={1000} disabled={isSubmitting} />
										</div>
										{editorError ? <div className="text-danger small mb-2">{editorError}</div> : null}
										<Button color="success" size="sm" className="mr-2" onClick={() => submitApply(row)} disabled={isSubmitting}>
											{isSubmitting ? "Anvender..." : "Anvend"}
										</Button>
										<Button color="secondary" size="sm" onClick={resetEditor} disabled={isSubmitting}>Annuller</Button>
									</div>
								</td>
							</tr>
						) : null}
					</React.Fragment>
				))}
			</tbody>
		</Table>
	);
};

const SplitV2Pagination = ({ page, totalPages, onPrev, onNext }) => {
	if (!totalPages || totalPages <= 1) return null;
	return (
		<div className="d-flex justify-content-between align-items-center mt-3">
			<Button size="sm" onClick={onPrev} disabled={page <= 1}>Forrige</Button>
			<span>Side {page} / {totalPages}</span>
			<Button size="sm" onClick={onNext} disabled={page >= totalPages}>Næste</Button>
		</div>
	);
};

const splitV2FormatTimestamp = (ts) => {
	if (!ts) return "-";
	const d = new Date(ts);
	if (Number.isNaN(d.getTime())) return String(ts);
	return I18N.datetime_shorter(d);
};

const SplitV2AuditLogsTable = ({ rows }) => {
	if (rows.length === 0) {
		return <p className="mt-4">Ingen logs fundet.</p>;
	}
	return (
		<Table bordered hover responsive size="sm" className="my-boxed-table mt-4">
			<thead className="thead-light">
				<tr>
					<th className="text-nowrap">Tid</th>
					<th className="text-nowrap">Action</th>
					<th className="text-nowrap">Event</th>
					<th className="text-nowrap">Fallback</th>
					<th className="text-nowrap">Actor</th>
					<th>Payload</th>
				</tr>
			</thead>
			<tbody>
				{rows.map((row) => (
					<tr key={row.ID}>
						<td className="text-nowrap">{splitV2FormatTimestamp(row.CreatedTs)}</td>
						<td className="text-nowrap">{row.Action || "-"}</td>
						<td className="text-nowrap">{row.SplitEventID > 0 ? row.SplitEventID : "-"}</td>
						<td className="text-nowrap">{row.FallbackWatchlistID > 0 ? row.FallbackWatchlistID : "-"}</td>
						<td className="text-nowrap">{row.ActorUserID > 0 ? row.ActorUserID : "-"}</td>
						<td>
							<details>
								<summary>Vis</summary>
								<pre className="mb-0 mt-2" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
									{JSON.stringify(row.Payload, null, 2)}
								</pre>
							</details>
						</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
};

const SplitV2AdminPane = ({ aua }) => {
	const splitV2PageSize = 25;
	const isUserGod = aua && aua.me && aua.me.IsGod === true;
	const [events, setEvents] = useState([]);
	const [fallbackRows, setFallbackRows] = useState([]);
	const [fallbackTotal, setFallbackTotal] = useState(0);
	const [fallbackPage, setFallbackPage] = useState(1);
	const [fallbackStatus, setFallbackStatus] = useState("all");
	const [auditRows, setAuditRows] = useState([]);
	const [auditTotal, setAuditTotal] = useState(0);
	const [auditPage, setAuditPage] = useState(1);
	const [upcomingPage, setUpcomingPage] = useState(1);
	const [processedPage, setProcessedPage] = useState(1);
	const [splitV2Tab, setSplitV2Tab] = useState(0);

	const categorized = useMemo(() => {
		const upcoming = [];
		const processed = [];
		for (const ev of events) {
			if (splitV2IsUpcoming(ev)) upcoming.push(ev);
			else processed.push(ev);
		}
		processed.sort((a, b) => String(b.EffectiveDate || "").localeCompare(String(a.EffectiveDate || "")));
		return { upcoming, processed };
	}, [events]);

	const fetchSplitV2Events = useCallback(() => {
		API.get("/a/split_v2_events", { limit: 1000, sort_by: "effective_date", sort_dir: "asc" }, (resp) => {
			setEvents(resp && Array.isArray(resp.events) ? resp.events : []);
		});
	}, []);

	const fetchSplitV2FallbackRows = useCallback(() => {
		API.get("/a/split_v2_fallback_watchlist", {
			status: fallbackStatus,
			page: fallbackPage,
			limit: splitV2PageSize,
			sort_by: "trigger_trade_date",
			sort_dir: "desc",
		}, (resp) => {
			setFallbackRows(resp && Array.isArray(resp.rows) ? resp.rows : []);
			setFallbackTotal(resp && typeof resp.total === "number" ? resp.total : 0);
		});
	}, [fallbackPage, fallbackStatus]);

	const fetchSplitV2AuditLogs = useCallback(() => {
		API.get("/a/split_v2_logs", { page: auditPage, limit: splitV2PageSize }, (resp) => {
			setAuditRows(resp && Array.isArray(resp.rows) ? resp.rows : []);
			setAuditTotal(resp && typeof resp.total === "number" ? resp.total : 0);
		});
	}, [auditPage]);

	useEffect(() => {
		if (!isUserGod) return;
		fetchSplitV2Events();
		fetchSplitV2FallbackRows();
		fetchSplitV2AuditLogs();
	}, [isUserGod, fetchSplitV2Events, fetchSplitV2FallbackRows, fetchSplitV2AuditLogs]);

	useEffect(() => {
		const upcomingTotalPages = Math.max(1, Math.ceil(categorized.upcoming.length / splitV2PageSize));
		if (upcomingPage > upcomingTotalPages) setUpcomingPage(upcomingTotalPages);
	}, [categorized.upcoming.length, upcomingPage]);

	useEffect(() => {
		const processedTotalPages = Math.max(1, Math.ceil(categorized.processed.length / splitV2PageSize));
		if (processedPage > processedTotalPages) setProcessedPage(processedTotalPages);
	}, [categorized.processed.length, processedPage]);

	const markSplitV2EventPreOpenDoneManual = useCallback((ev) => {
		if (!splitV2CanMarkPreOpenDone(ev)) return;
		if (!window.confirm(`Markér pre-open done manuelt for ${ev.Exchange}:${ev.Ticker}?`)) return;
		const noteRaw = window.prompt("Note (valgfri):", "");
		if (noteRaw === null) return;
		API.post("/a/split_v2_events_mark_preopen_done", { id: String(ev.ID), note: noteRaw.trim() }, (resp, status) => {
			if (status === 200 && resp) {
				fetchSplitV2Events();
				fetchSplitV2AuditLogs();
			}
		});
	}, [fetchSplitV2AuditLogs, fetchSplitV2Events]);

	const toggleSplitV2FallbackSeen = useCallback((rowID, isSeen) => {
		API.post("/a/split_v2_fallback_watchlist_seen", { id: rowID, seen: isSeen ? "1" : "0" }, (resp, status) => {
			if (status === 200 && resp) fetchSplitV2FallbackRows();
		});
	}, [fetchSplitV2FallbackRows]);

	const relistSplitV2FallbackRow = useCallback((row) => {
		if (!splitV2CanRelist(row)) return;
		if (!window.confirm(`Relist ${row.Exchange}:${row.Ticker} og løs alle åbne fallback-rækker for aktien?`)) return;
		API.post("/a/split_v2_fallback_watchlist_relist", { id: row.ID }, (resp, status) => {
			if (status === 200 && resp) fetchSplitV2FallbackRows();
		});
	}, [fetchSplitV2FallbackRows]);

	const delistAgainSplitV2FallbackRow = useCallback((row) => {
		if (!splitV2CanDelistAgain(row)) return;
		if (!window.confirm(`Delist ${row.Exchange}:${row.Ticker} og genåbn denne fallback-række?`)) return;
		API.post("/a/split_v2_fallback_watchlist_delist", { id: row.ID }, (resp, status) => {
			if (status === 200 && resp) fetchSplitV2FallbackRows();
		});
	}, [fetchSplitV2FallbackRows]);

	const applySplitV2FallbackRow = useCallback((row, payload, done) => {
		API.post("/a/split_v2_fallback_watchlist_apply", {
			id: row.ID,
			ratio_new: String(payload.ratio_new),
			ratio_old: String(payload.ratio_old),
			note: payload.note || "",
		}, (resp, status) => {
			if (status === 200 && resp) {
				fetchSplitV2FallbackRows();
				if (done) done(true, "");
				return;
			}
			if (done) done(false, resp && resp.error ? String(resp.error) : "Anvend split fejlede.");
		});
	}, [fetchSplitV2FallbackRows]);

	const openSplitV2FallbackApplySummary = useCallback((row) => {
		SplitV2FallbackApplyModalInit({
			StockLabel: `${row.Exchange}:${row.Ticker}`,
			RowStatus: row.Status || "",
			ApplyStatus: row.ApplyStatus || "",
			Processed: row.ApplyProcessed,
			Failed: row.ApplyFailed,
			ClosedPositions: row.ApplyClosedPositions,
			SkippedIDs: row.ApplySkippedIDs || "",
			FailedIDs: row.ApplyFailedIDs || "",
			ActorUserID: row.ApplyActorUserID || "",
			AppliedTs: row.ApplyAppliedTs || "",
			Note: row.ApplyNote || "",
		});
	}, []);

	if (!isUserGod) return null;

	const upcomingTotalPages = Math.max(1, Math.ceil(categorized.upcoming.length / splitV2PageSize));
	const processedTotalPages = Math.max(1, Math.ceil(categorized.processed.length / splitV2PageSize));
	const fallbackTotalPages = Math.max(1, Math.ceil(fallbackTotal / splitV2PageSize));
	const auditTotalPages = Math.max(1, Math.ceil(auditTotal / splitV2PageSize));

	const splitV2Tabs = [
		<span key="upcoming-events">Kommende splits</span>,
		<span key="processed-events">Behandlede splits</span>,
		<span key="potential-splits">Potentielle splits</span>,
		<span key="logs">Logs</span>,
	];

	const pagedUpcomingEvents = categorized.upcoming.slice((upcomingPage - 1) * splitV2PageSize, upcomingPage * splitV2PageSize);
	const pagedProcessedEvents = categorized.processed.slice((processedPage - 1) * splitV2PageSize, processedPage * splitV2PageSize);

	return (
		<div className="split-v2-admin-pane">
			<h2 className="py-3">Splits</h2>
			<div className="split-v2-admin-tabs mb-3">
				<YTab
					selected={splitV2Tab}
					items={splitV2Tabs}
					add_classes={["split-v2-admin-tab"]}
					unselected_class="split-v2-admin-tab-unselected"
					selected_class="split-v2-admin-tab-selected"
					onSelect={setSplitV2Tab}
				/>
			</div>
			{splitV2Tab === 0 && (
				<div>
					<div className="alert alert-light border py-2 px-3 mb-3 small">Datakilde: Morningstar Corporate Actions.</div>
					<SplitV2EventsTable events={pagedUpcomingEvents} onMarkPreOpenDone={markSplitV2EventPreOpenDoneManual} />
					<SplitV2Pagination
						page={upcomingPage}
						totalPages={upcomingTotalPages}
						onPrev={() => setUpcomingPage((p) => Math.max(1, p - 1))}
						onNext={() => setUpcomingPage((p) => Math.min(upcomingTotalPages, p + 1))}
					/>
				</div>
			)}
			{splitV2Tab === 1 && (
				<div>
					<div className="alert alert-light border py-2 px-3 mb-3 small">Datakilde: Morningstar Corporate Actions.</div>
					<SplitV2EventsTable events={pagedProcessedEvents} onMarkPreOpenDone={markSplitV2EventPreOpenDoneManual} />
					<SplitV2Pagination
						page={processedPage}
						totalPages={processedTotalPages}
						onPrev={() => setProcessedPage((p) => Math.max(1, p - 1))}
						onNext={() => setProcessedPage((p) => Math.min(processedTotalPages, p + 1))}
					/>
				</div>
			)}
			{splitV2Tab === 2 && (
				<div>
					<div className="alert alert-light border py-2 px-3 mb-3 small">Datakilde: intern prisfluktuationsdetektion.</div>
					<div className="d-flex align-items-center mb-2">
						<label className="mb-0 mr-2">Status</label>
						<select className="form-control form-control-sm" style={{ maxWidth: 340 }} value={fallbackStatus} onChange={(e) => { setFallbackPage(1); setFallbackStatus(e.target.value); }}>
							<option value="all">Alle</option>
							<option value="open">Åbne</option>
							<option value="failed_apply_split">Fejlet (manuel opfølgning)</option>
							<option value="resolved_relist">Relistet</option>
							<option value="resolved_manual">Løst manuelt</option>
							<option value="resolved_apply_split">Split anvendt</option>
							<option value="resolved_split_pending_relist">Split anvendt (afventer relist)</option>
						</select>
					</div>
					<SplitV2FallbackWatchlistTable
						rows={fallbackRows}
						onToggleSeen={toggleSplitV2FallbackSeen}
						onRelist={relistSplitV2FallbackRow}
						onDelistAgain={delistAgainSplitV2FallbackRow}
						onApplySplit={applySplitV2FallbackRow}
						onOpenApplySummary={openSplitV2FallbackApplySummary}
					/>
					<SplitV2Pagination
						page={fallbackPage}
						totalPages={fallbackTotalPages}
						onPrev={() => setFallbackPage((p) => Math.max(1, p - 1))}
						onNext={() => setFallbackPage((p) => Math.min(fallbackTotalPages, p + 1))}
					/>
				</div>
			)}
			{splitV2Tab === 3 && (
				<div>
					<div className="alert alert-light border py-2 px-3 mb-3 small">Audit logs fra split_v2 flow.</div>
					<SplitV2AuditLogsTable rows={auditRows} />
					<SplitV2Pagination
						page={auditPage}
						totalPages={auditTotalPages}
						onPrev={() => setAuditPage((p) => Math.max(1, p - 1))}
						onNext={() => setAuditPage((p) => Math.min(auditTotalPages, p + 1))}
					/>
				</div>
			)}
		</div>
	);
};

  const PreferencesInner = memo(function PreferencesInner({ aua, q_err }) {
	const [loginOpened, setLoginOpened] = useState(false);
	if (!aua.me) {
	  if (!loginOpened) {
		OpenLogin();
		setLoginOpened(true);
	  }
	  return null;
	}
  
	const tabs = useMemo(() => {
	  const baseTabs = [
		{
		  id: 'account',
		  render_title: () => <span><T>Account</T></span>,
		  render_pane: () => <AccountPane aua={aua} auaerr={q_err} />
		},
		/*{
		  id: 'privacy',
		  render_title: () => <span><T>Privacy</T></span>,
		  render_pane: () => <PrivacyPane />
		},*/
	  ];

	  if (aua.me && aua.me.IsGod === true) {
		baseTabs.push({
		  id: 'split_v2_admin',
		  render_title: () => <span><T>Split V2</T></span>,
		  render_pane: () => <SplitV2AdminPane aua={aua} />
		});
	  }

	  return baseTabs;
	}, [aua, q_err]);
  
	const tid = R.get_arg("p");
	let tabIndex = tabs.findIndex(t => t.id === tid);
	if (tabIndex < 0) tabIndex = 0;
  
	const onSelectTab = idx => R.go("/preferences?p=:p", { p: tabs[idx].id });
	const TabItems = tabs.map(t => t.render_title());
  
	return (
	  <Container>
		<Row className="py-5">
		  <Col md="3">
			<h2 className="mb-4"><T>Preferences</T></h2>
			<T>
			  <YTab
				selected={tabIndex}
				items={TabItems}
				add_classes={["mb-3"]}
				onSelect={onSelectTab}
			  />
			</T>
		  </Col>
		  <Col md="9">
			<div className="ad_pref_right p-5">
			  {tabs[tabIndex].render_pane()}
			</div>
		  </Col>
		</Row>
	  </Container>
	);
  });

const Preferences = (props) => <AUAContainer><PreferencesInner {...props}/></AUAContainer>;

export default Preferences;



// WEBPACK FOOTER //
// ./src/p/Preferences.js